import { Component, Input, EventEmitter, Output, ViewChild, OnInit, AfterViewInit } from '@angular/core';
import { ArquivoUpload } from '../../../arquivos/arquivos/upload';
import { ArquivoCardViewComponent } from '../../../arquivos/arquivos/components/card-view';
import { arquivoReferenciaCliente } from '../../../arquivos/referencias';

@Component({
    selector: 'sgt-cliente-arquivo',
    templateUrl: './cliente-arquivo.component.html',
    styleUrls: ['./cliente-arquivo.component.less']
})
export class ClienteArquivoComponent implements AfterViewInit {
    referencia = arquivoReferenciaCliente;
    @Input() idCliente: number;
    @Input() canEdit = true;
    @Input() editMode: boolean;
    @Input() arquivosUpload: ArquivoUpload[];
    @Output() arquivosUploadChange = new EventEmitter<ArquivoUpload[]>();
    @Input() mensagemInformativa = `
        Adicione anexos como:
        <ul class="mb-0">
            <li>Balanço Patrimonial</li>
            <li>Contrato Social</li>
            <li>Notas Fiscais</li>
            <li>Fotos do Estabelecimento</li>
        </ul>
    `;

    @ViewChild('cardView') cardView: ArquivoCardViewComponent;

    ngAfterViewInit(): void {
        if (this.editMode) {
            this.cardView?.search();
        }
    }

    resize() {
        jQuery(window).trigger('resize');
    }

    /** Verifica se os arquivos do cliente estão válidos */
    isValid(): boolean {
        return true;
    }
}
